/* @flow */
import { CancelIcon } from '@/assets/icons'
import React from 'react'
class Fail extends React.PureComponent {
  handleClick() {
    const { onMessageClick } = this.props
    if (onMessageClick) {
      onMessageClick(import.meta.env.VITE_FRONT_URL)
    }
  }
 
  render() {
    const { title, body } = this.props
    return (
      <div className="flex items-center gap-2"  onClick={this.handleClick.bind(this)}>
        <div className="shrink-0">
          <CancelIcon />
        </div>

        <div className="message__text">
          <div className="message__main-text text-lg font-bold">{title}</div>
          <div className="message__sub-text">{body}</div>
        </div>
      </div>
    )
  }
}

export default Fail
